import type { UserRole } from '@xdocs/schemas';

/**
 * Client-side role ordering for UI GATING ONLY (F68/§15.2: "App REFLECTS
 * role by revealing entry points; enforcement is server-side at the
 * action"). Every admin.* / impersonation.* WS op re-checks
 * `requireRole`/`requireModerationTarget` server-side regardless of what
 * this renders — this never substitutes for that. `@xdocs/web` cannot
 * import `packages/core/src/authz.ts`'s `roleSatisfies` (dependency
 * direction: web → schemas/ws-protocol/ui/i18n only, NEVER core/db), so the
 * same tiny ordering is duplicated here rather than reached for across the
 * boundary.
 */
const ROLE_RANK: Record<UserRole, number> = { user: 0, moderator: 1, admin: 2 };

export function roleSatisfies(role: UserRole | null | undefined, minimum: UserRole): boolean {
  if (!role) return false;
  return ROLE_RANK[role] >= ROLE_RANK[minimum];
}
